import React from 'react';
import ChatbotFrame from '../../components/public/ChatbotFrame';

const ChatbotFramePage = () => <ChatbotFrame />;

export default ChatbotFramePage;
